import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    buttons: {
      delete: 'Delete',
      close: 'Close',
      report: 'Report',
      proceed: 'Proceed',
      vote: 'Vote',
      cancel: 'Cancel',
      clear: 'Clear',
      reset: 'Reset',
      deactivate: 'Deactivate',
      save: 'Save',
      update: 'Update',
      share: 'Share',
      create: 'Create',
      more: 'More',
      search: 'Search',
      submit: 'Submit',
      back: 'Back',
      preview: 'Preview',
      edit: 'Edit',
      example: 'Example',
      refresh: 'Refresh',
      copyLink: 'Copy link',
      newTab: 'New tab',
      prev: 'Prev',
      next: 'Next',
      register: 'Register',
      login: 'Log in',
      recover: 'Recover',
      createAnAccount: 'Create an account',
      answer: 'Answer',
      ok: 'OK',
      nextQuestion: 'Next question',
    },
    errors: {
      somethingWentWrong: 'Something went wrong !',
      requestTimeout: 'Request timeout !',
    },
    email: {
      label: 'Email',
      placeholder: 'username@domain.com',
    },
    username: {
      label: 'Username',
    },
    password: {
      password: 'Password',
      currentPassword: 'Current password',
      newPassword: 'New password',
    },
    date: {
      placeholder: 'DD-MM-YYYY',
      format: 'DD-MM-YYYY',
    },
    dateOfBirth: {
      label: 'Date of birth',
    },
    country: {
      label: 'Country of residence',
      placeholder: 'select ...',
    },
    sex: {
      label: 'Sex',
      female: 'Female',
      male: 'Male',
    },
    info: {
      nothingToDisplay: 'Empty',
      loading: 'Loading ...',
      noQuestionsFound: 'No questions found',
    },
    validation: {
      required: 'is required',
      minLength: 'must be {{ min }} characters at min',
      maxLength: 'must be {{ max }} characters at max',
      invalid: 'is invalid',
      invalidChars: 'contains invalid character(s)',
    },
    question: {
      selectExactly: 'Select exactly {{ count }} options',
      selectExactly_one: 'Select exactly {{ count }} option',
      selectBetween: 'Select between {{ min }} and {{ max }} options',
    },
    list: {
      pagination: {
        placeholder: 'select ...',
        pageNo: 'Page #{{ pageNo }}',
      },
    },
  },
}
